module.exports = __webpack_public_path__ + "img/overall-view-pc.1bd7768.png";